import React, { useState, lazy } from 'react';
import { motion } from 'framer-motion';
import { Share2, MoreHorizontal, ArrowUpRight, Heart, ChevronDown } from 'lucide-react';
import { Pin, Board } from '../types';
import { BoardSelector } from './BoardSelector';
interface PinCardProps {
  pin: Pin;
  boards: Board[];
  onClick: (pin: Pin) => void;
  onToggleLike: (id: string) => void;
  onSave: (pinId: string, boardId: string) => void;
  onCreateBoard: (name: string) => void;
}
export function PinCard({
  pin,
  boards,
  onClick,
  onToggleLike,
  onSave,
  onCreateBoard
}: PinCardProps) {
  const [isHovered, setIsHovered] = useState(false);
  const [showBoardSelector, setShowBoardSelector] = useState(false);
  const handleSaveClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    setShowBoardSelector(!showBoardSelector);
  };
  const handleLikeClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onToggleLike(pin.id);
  };
  return <div className="relative mb-6 break-inside-avoid cursor-zoom-in group" onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => {
    setIsHovered(false);
    setShowBoardSelector(false);
  }} onClick={() => onClick(pin)} data-id="element-217">
      <div className="relative rounded-2xl overflow-hidden bg-gray-100 transition-shadow duration-300 group-hover:shadow-lg" data-id="element-218">
        <img src={pin.imageUrl} alt={pin.title} className="w-full h-auto object-cover block" loading="lazy" data-id="element-219" />

        {/* Desktop Overlay */}
        <div className="absolute inset-0 bg-black/20 opacity-0 group-hover:opacity-100 transition-opacity duration-200 hidden md:flex flex-col justify-between p-3" data-id="element-220">
          <div className="flex justify-between items-start" data-id="element-221">
            <div className="relative" data-id="element-222">
              <button onClick={handleSaveClick} className={`flex items-center gap-1 px-4 py-2.5 rounded-full font-semibold text-white transition-transform active:scale-95 text-sm ${pin.isSaved ? 'bg-black' : 'bg-red-600 hover:bg-red-700'}`} data-id="element-223">
                {pin.isSaved ? 'Saved' : 'Save'}
                <ChevronDown className="w-4 h-4" data-id="element-224" />
              </button>

              <BoardSelector boards={boards} isOpen={showBoardSelector} onSelect={boardId => {
              onSave(pin.id, boardId);
              setShowBoardSelector(false);
            }} onClose={() => setShowBoardSelector(false)} onCreateBoard={onCreateBoard} data-id="element-225" />
            </div>
          </div>

          <div className="flex justify-between items-end gap-2" data-id="element-226">
            <a href="#" onClick={e => e.stopPropagation()} className="flex items-center gap-2 px-3 py-2 bg-white/90 hover:bg-white rounded-full text-xs font-semibold text-gray-900 truncate max-w-[140px] transition-colors backdrop-blur-sm" data-id="element-227">
              <ArrowUpRight className="h-3 w-3" data-id="element-228" />
              <span className="truncate" data-id="element-229">source.com</span>
            </a>

            <div className="flex gap-2" data-id="element-230">
              <button onClick={handleLikeClick} className={`p-2 rounded-full transition-colors backdrop-blur-sm ${pin.isLiked ? 'bg-red-50 text-red-600' : 'bg-white/90 hover:bg-white text-gray-900'}`} data-id="element-231">
                <Heart className={`h-4 w-4 ${pin.isLiked ? 'fill-current' : ''}`} data-id="element-232" />
              </button>
              <button className="p-2 bg-white/90 hover:bg-white rounded-full text-gray-900 transition-colors backdrop-blur-sm" data-id="element-233">
                <Share2 className="h-4 w-4" data-id="element-234" />
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile/Always Visible Info */}
      <div className="mt-3 px-1" data-id="element-235">
        <h3 className="text-sm font-semibold text-gray-900 truncate leading-tight" data-id="element-236">
          {pin.title}
        </h3>
        <div className="flex items-center justify-between mt-1.5" data-id="element-237">
          <div className="flex items-center gap-2" data-id="element-238">
            <img src={pin.user.avatar} alt={pin.user.name} className="w-5 h-5 rounded-full object-cover bg-gray-200" data-id="element-239" />
            <p className="text-xs text-gray-500 truncate max-w-[100px]" data-id="element-240">
              {pin.user.name}
            </p>
          </div>
          <div className="flex items-center gap-1 text-xs text-gray-400" data-id="element-241">
            <Heart className={`w-3 h-3 ${pin.isLiked ? 'fill-red-500 text-red-500' : ''}`} data-id="element-242" />
            <span data-id="element-243">{pin.likes}</span>
          </div>
        </div>
      </div>
    </div>;
}